import { Subscription, ReplaySubject, Subject, Observable, fromEvent, of, } from 'rxjs';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, ViewChild, AfterViewInit, Inject, ElementRef, Optional, OnChanges, SimpleChanges, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { ApiService } from '../../../api.service';
import { ToastrService } from 'ngx-toastr';
declare var $: any;
import Swal from 'sweetalert2';
import { DataTableDirective } from 'angular-datatables';
import { environment } from '../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import * as FileSaver from 'file-saver';
import { FormBuilder, FormGroup, FormArray, Validators, FormControl, ValidatorFn, AbstractControl, ValidationErrors, AsyncValidatorFn, } from '@angular/forms';
import { emailPattern, noWhitespaceInRequiredValidator, mobilePattern, datePickerMinDate, convertToNgbDate, allowedBillFiles, allowedBillGPayFiles, allowedBillQRFiles, allowedFiles, allowedReferralFiles, medicine_supply_list, allowedQuotationFiles } from '../../../shared/constants';
import { NgSelectModule } from '@ng-select/ng-select';
import { timer } from 'rxjs';
import { debounceTime, map, distinctUntilChanged, filter, take, takeUntil, switchMap, catchError, } from 'rxjs/operators';
import { inject, TemplateRef, ViewEncapsulation } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { NgxFileDropEntry, FileSystemFileEntry, FileSystemDirectoryEntry } from 'ngx-file-drop';
import { addDays, isBefore, isSameDay } from 'date-fns';
import { CaseDetailsComponent } from '../../case-details/case-details.component';
import { NavbarComponent } from '../../../navbar/navbar.component';

@Component({
	selector: 'app-treatment-cost-form',
	templateUrl: './treatment-cost-form.component.html',
	styleUrl: './treatment-cost-form.component.css'
})
export class TreatmentCostFormComponent implements OnChanges {
	@Input() followupId: any = null;
	@Input() id: any = null;
	@Input() btn_type: any = 1;
	@Input() icd_code_name: any = null;
	modalId: any = "treatmentModalFoll";
	@Output() created = new EventEmitter<any>();
	treatmentForm: FormGroup = this.formBuilder.group({
		id: [null],
		icdcode_id: [null, [Validators.required]],
		treatment: [null, [Validators.required]],
		hospital_id: [null, [Validators.required]],
		quotation: [null, [Validators.required]],
		amount: [null, [Validators.required, Validators.pattern(/^[+-]?([0-9]*[.])?[0-9]+$/)]],
		followup_id: [null, [Validators.required]]
	});
	get f3() { return this.treatmentForm.controls }
	customErrorTreatment: any = {};
	allowedQuotationFiles = allowedQuotationFiles;
	treatmentFormSubmitted = false;
	icd_code_list: any[] = [];
	hospitalList: any[] = [];
	loadingICD = false;
	constructor(private toastr: ToastrService, private apiService: ApiService, public formBuilder: FormBuilder, private router: Router, private activeRoute: ActivatedRoute, @Optional() @Inject(NavbarComponent) public navbar: NavbarComponent) { }
	ngOnChanges(changes: SimpleChanges): void {
		if (
			changes &&
			changes.id &&
			changes.id.currentValue
		) {
			this.modalId = "treatmentModalFoll" + atob(changes.id.currentValue);
		}
	}
	getHospitalList() {
		this.apiService.getHospital({}).subscribe({
			next: (data: any) => {
				this.hospitalList = data.data;
			}, error: (error) => {
				this.hospitalList = [];
			},
		});
	}
	getICDCodes() {
		this.loadingICD = true;
		this.apiService.getAllICDCodes().subscribe({
			next: (data: any) => {
				this.loadingICD = false;
				this.icd_code_list = data.data;
				if (!this.f3.icdcode_id.value && this.icd_code_name) {
					const len = this.icd_code_list.length;
					for (let i = 0; i < len; i++) {
						if (this.icd_code_list[i].name == this.icd_code_name) {
							this.f3.icdcode_id.setValue(this.icd_code_list[i].id);
						}
					}
				}
			}, error: (error) => {
				this.loadingICD = false;
				this.icd_code_list = [];
			}
		})
	}
	addICDCode(name: any) {
		if (!name) {
			this.toastr.error("Please enter ICD code", 'Error', {
				timeOut: 3000,
				tapToDismiss: true,
				closeButton: true
			});
			return;
		}
		Swal.fire({
			title: 'Warning',
			html: 'Are you sure you want to create ICD code <strong>' + name + '</strong>?',
			icon: 'question',
			showCancelButton: true,
			showConfirmButton: true,
			confirmButtonText: 'Create',
			cancelButtonText: 'Cancel'
		}).then((result) => {
			if (result.value) {
				this.apiService.createUpdateICDCode({ name: name }).subscribe({
					next: (data) => {
						this.toastr.success("ICD code created successfully", 'Success', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
						this.f3.icdcode_id.setValue(data);
						this.getICDCodes();
					}, error: (error) => {
						if (error.status == 401) { return }
						this.toastr.error("Something went wrong", 'Error', {
							timeOut: 3000,
							tapToDismiss: true,
							closeButton: true
						});
					}
				});
			}
		})
	}
	loadingTreatmentCosts = false;
	treat_cost: any = null;
	getTreatmentCost() {
		this.loadingTreatmentCosts = true;
		this.apiService.getTreatmentCosts({ id: this.id }).subscribe({
			next: (data: any) => {
				this.loadingTreatmentCosts = false;
				this.treat_cost = data.data;
				this.treatmentForm.setValue({
					id: this.treat_cost.enc_id,
					icdcode_id: this.treat_cost.icdcode,
					treatment: this.treat_cost.treatment,
					hospital_id: this.treat_cost.hospital,
					quotation: this.treat_cost.quotation,
					amount: this.treat_cost.amount,
					followup_id: this.treat_cost.followup
				});
				this.getICDCodes();
				$("#" + this.modalId).modal("show");
			}, error: (error) => {
				this.loadingTreatmentCosts = false;
				this.treat_cost = [];
			}
		})
	}

	quotationFileUploaded(path: any) {
		this.f3.quotation.setValue(path);
	}

	isTreatmentFieldInvalid(field: string) {
		if (this.f3[field].invalid) {
			return true;
		}
		if (this.f3[field].disabled && this.f3[field].hasValidator(Validators.required) && !this.f3[field].value) {
			return true;
		}
		return false;
	}

	showErrorTreatment(field: string) {
		if (this.isTreatmentFieldInvalid(field) && (this.treatmentFormSubmitted || this.f3[field].touched || this.f3[field].dirty)) {
			return true;
		}
		return false;
	}

	clearTreatmentCustomError() {
		Object.keys(this.f3).forEach(key => {
			if (this.f3[key].hasError('incorrect')) {
				try {
					delete this.f3[key].errors?.incorrect;
					this.f3[key].updateValueAndValidity();
				} catch (error) {
				}
			}
		});
		this.customErrorTreatment = {};
	}

	saveTreatmentLoader = false;
	saveTreatmentExpense() {
		this.treatmentFormSubmitted = true;
		this.clearTreatmentCustomError();
		if (this.treatmentForm.invalid) {
			this.toastr.info("Please check required fields", 'Error', { timeOut: 3000, tapToDismiss: true, closeButton: true });
			return;
		}
		this.saveTreatmentLoader = true;
		this.apiService.createUpdateTreatmentCost(this.treatmentForm.value).subscribe({
			next: (data: any) => {
				this.toastr.success('Saved successfully', 'Success', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
				this.saveTreatmentLoader = false;
				this.created.emit(true);
				$("#" + this.modalId).modal("hide");
			}, error: (error) => {
				this.saveTreatmentLoader = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			},
		});
	}

	openTreatmentModal() {
		this.getHospitalList();
		if (this.id) {
			this.getTreatmentCost();
		} else {
			this.f3.followup_id.setValue(this.followupId);
			this.getICDCodes();
			$("#" + this.modalId).modal("show");
		}
	}
}
